/* Get the element you want displayed in fullscreen */



import Quill from "quill";
import {QuestionManagementService} from "../../app/Services/question-management/question-management.service";



// import Sortable from 'sortablejs';
var elem = document.documentElement;

// function getelementsoratable() {
//     var el = document.getElementById('items');
// var sortable = Sortable.create(el);
//     return sortable;
// }

export function tablesorting(){
    $(document).ready(function () {
        $('#example').DataTable();
        $('.dataTables_length').addClass('bs-select');
      });
}
  
function showpasword() {
    console.log('sow p')
    var x = document.getElementById("userPassword");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
}
/* Function to open fullscreen mode */
function openFullscreen() {
    // if (data === "viewbill" || data === "bill") {
    // if (!window.fullScreen) {
    // console.log(document.getElementById('ilText1'))
    try {
        if (elem.requestFullscreen) {
            try {
                elem.requestFullscreen().then(r => {
                    console.log(r);
                }).catch((er) => {
                    console.log('Full screen disabled');
                    // console.clear();
                });
            } catch (e) {
                console.log(e);
            }
        } else if (elem.mozRequestFullScreen) { /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
            elem = window.top.document.body; //To break out of frame in IE
            elem.msRequestFullscreen();
        }
    } catch (e) { console.log(e); console.clear(); }
    // }
    // }
}

function getFocuseElem(elem) {
    // console.log(elem);z
    if (elem !== '' && elem !== null) {
        if (document.getElementById(elem) === null) {
            try {
                var d = document.getElementById(elem);
                if (d) {
                    d.focus();
                    // var res = elem.substring(0, 5);
                    // if (res === 'textq')
                    // d.select();
                }
            } catch (e) { }
            return;
        }
        if (document.getElementById(elem).focus !== true) {
            var d = document.getElementById(elem);
            if (d) {
                d.focus();
                // var res = elem.substring(0, 5);
                // if (res === 'textq')
                // d.select();
            }
        }
    }
}

function getISFocused(elem) {
    if (document.getElementById(elem) !== null) {
        if (document.getElementById(elem).focus === true) {
            return true;
        }
        else {
            return false;
        }
    } else {
        return false;
    }
}

function getSelectedElem(elem) {
    console.log(elem);
    if (elem !== '' && elem !== null) {
        if (document.getElementById(elem) === null) {
            try {
                var d = document.getElementById(elem);
                if (d) {
                    d.select();
                }
            } catch (e) {
                if (document.getElementById(elem).select !== true) {
                    var d = document.getElementById(elem);
                    if (d) {
                        d.select();
                        // var res = elem.substring(0, 5);
                        // if (res === 'textq')
                        // d.select();
                    }
                }
            }
            return;
        }
        if (document.getElementById(elem).select !== true) {
            var d = document.getElementById(elem);
            if (d) {
                d.select();
                // var res = elem.substring(0, 5);
                // if (res === 'textq')
                // d.select();
            }
        }
    }
}

function disableFocusELEM(elem) {
    if (elem !== '' && elem !== null) {
        var d = document.getElementById(elem);
        if (d) {
            d.blur();
        }
    }
}

/* Function to close fullscreen mode */
function closeFullscreen(data) {
    if (data === 'billlist' || data === 'bill') {
        return;
    }
    // if (data === "viewbill" || data === "bill") {
    // if (window.fullScreen) {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
        window.top.document.msExitFullscreen();
    }
    // }
    // }
}

// // Events
// var output = document.getElementById("myP");
// document.addEventListener("fullscreenchange", function () {
//     output.innerHTML = "fullscreenchange event fired!";
// });
// document.addEventListener("mozfullscreenchange", function () {
//     output.innerHTML = "mozfullscreenchange event fired!";
// });
// document.addEventListener("webkitfullscreenchange", function () {
//     output.innerHTML = "webkitfullscreenchange event fired!";
// });
// document.addEventListener("msfullscreenchange", function () {
//     output.innerHTML = "msfullscreenchange event fired!";
// });


// function mymethod() {
//     alert('holllllll');
// }

// function myfunction(params1, params2) {
//     console.log('param1', params1);
//     console.log('param2', params2);
// }
function hideModal() {
    document.getElementsByClassName("modal-backdrop show").style.display = "none";
}
function ip_local() {
    var ipaddress = false;
    var findIP = new Promise(r => { var w = window, a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({ iceServers: [] }), b = () => { }; a.createDataChannel(""); a.createOffer(c => a.setLocalDescription(c, b, b), b); a.onicecandidate = c => { try { c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r) } catch (e) { } } })
    // return findIP;
    findIP.then(function (ip) {
        ipaddress = ip;
    });
    return ipaddress;
    // var ip = false;
    // var ipadd = "";
    // var ipaddress = "";
    // window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || false;

    // if (window.RTCPeerConnection) {
    //     ip = [];
    //     var pc = new RTCPeerConnection({ iceServers: [] }), noop = function () { };
    //     pc.createDataChannel('');
    //     pc.createOffer(pc.setLocalDescription.bind(pc), noop);

    //     pc.onicecandidate = function (event) {
    //         if (event && event.candidate && event.candidate.candidate) {
    //             var s = event.candidate.candidate.split('\n');
    //             ip.push(s[0].split(' ')[4]);
    //         }
    //     };
    // }
    // console.log(ip["0"], 'IP ADDRESS');
    // return ip;
}
ip_local();
function GetComputerName() {
    // var network = new ActiveXObject('WScript.Network');
    // console.log(network);
    // alert('User ID : ' + network.UserName + '\nComputer Name : ' + network.ComputerName + '\nDomain Name : ' + network.UserDomain);
    // document.getElementById('<%= currUserID.ClientID %>').value = network.UserName;
    // document.getElementById('<%= currMachineName.ClientID %>').value = network.ComputerName;
    // document.getElementById('<%= currMachineDOmain.ClientID %>').value = network.UserDomain;

    // "use strict";
    // var computerName = require("computer-name");
    // var toExport = {
    //     COMPUTERNAME: computerName.COMPUTERNAME
    // };
    // console.log(computerName());
    // module.exports = toExport;

}
function load() {
    var evt = document.createEvent("Events");
    evt.initEvent("MyExtensionEvent", true, false);
    //element.dispatchEvent(evt);
    document.getElementById("compname").dispatchEvent(evt); //this raises the MyExtensionEvent event , which assigns the client computer name to the hidden variable.
}

function showcomp() {
    alert("your computer name is " + document.getElementById("compname").value);
}

function removetag() {
    document.getElementsByTagName("a").removeAttribute("href"); 
  }


// function MATHtest() { 
//     console.log('mathsdatatest')
//   document.getElementById('mathjax').onclick = () => {
//     var latex = prompt("Enter a LaTeX formula:", "e=mc^2");
//     var range = quill.getSelection(true);
//     quill.deleteText(range.index, range.length);
//     quill.insertEmbed(range.index, 'mathjax', latex);
//     quill.insertText(range.index + range.length + 1 , ' '); 
//     quill.setSelection(range.index + range.length + 1);
//    alert('test');
// }
// }
export function emptylatex(){
    latex='';
}
export function emptymathjax(){
    mathjax='';
}
export function emptyindex(){
    index='';
}
export let latex='';
export let mathjax='';
export let index='';

export function RenderMathjax(latex){
    let MathJaxNode = document.createElement("DIV");
        MathJaxNode.style.visibility = "hidden";
        MathJaxNode.innerHTML = '\\(' + latex + '\\)';
        document.body.appendChild(MathJaxNode);
        MathJax.typesetPromise();
        let svg = MathJaxNode.innerHTML;
        document.body.removeChild(MathJaxNode);
        //mathjax=svg;
        return svg;
}
export function MATHtest(){
  
 
      
    // When the MathJax button is clicked, add a mathjax equation at the current selection
    document.getElementById('mathjax').onclick = () => {
       
        try{
         
            
            // console.log(quillobject,'quillobject');
 
             latex = prompt("Enter a LaTeX formula:", "e=mc^2");
            
           
            var quill=document.getElementById('testquill');
           
            console.log(quill,'quill11');
            // latex=latex+' '.repeat(1);
            var range = quill.lastChild.__quill.getSelection(true);
            index=range.index;
            console.log(range,'test quill')
            //quill.lastChild.__quill.deleteText(range.index, range.length);
            quill.lastChild.__quill.insertEmbed(range.index, 'mathjax', latex);
            //quill.lastChild.__quill.insertText(range.index + range.length + 1 , ' ');
            quill.lastChild.__quill.setSelection(range.index + range.length + 1);
            
          
        }
        catch(e){
console.log(e);

        }
      
       
    }
    const Parchment = Quill.imports.parchment;
const Delta = Quill.imports.delta;

// Extend the embed
class Mathjax extends Parchment.Embed {

    // Create node
    static create(value) 
    {
        const node = super.create(value);    
        if (typeof value === 'string') {
            node.innerHTML = "&#65279;" + this.tex2svg(value) + "&#65279;";
            node.contentEditable = 'false';
            node.setAttribute('data-value', value);      
        }
        return node;
    }

    // Return the attribute value (probably for Delta)
    static value(domNode) 
    {
        return domNode.getAttribute('data-value');
    }

    // Manually render a MathJax equation until version 3.0.2 is not released
    static tex2svg(latex)
    {
        // Create a hidden node and render the formula inside
        let MathJaxNode = document.createElement("DIV");
        MathJaxNode.style.visibility = "hidden";
        MathJaxNode.innerHTML = '\\(' + latex + '\\)';
        document.body.appendChild(MathJaxNode);
        MathJax.typesetPromise();
        let svg = MathJaxNode.innerHTML;
        document.body.removeChild(MathJaxNode);
        mathjax=svg;
        return svg;
    }
    /*
    //  Never called ? See : https://stackoverflow.com/questions/60935100/html-method-in-quill-formula-js
    html() {
        const { mathjax } = this.value();
        return `<span>${mathjax}</span>`;
      }
     */
}

// Set module properties
Mathjax.blotName = 'mathjax';
Mathjax.className = 'ql-mathjax';
Mathjax.tagName = 'SPAN';

// Register the module
Quill.register(Mathjax);
    

}

